// @flow

import { type IncomingPayment } from './types';

const EMPTY_CUSTOMER_NAME = 'CUSTOMER NAME NOT INFORMED';

export function getCustomerName(incomingPayment: IncomingPayment): ?string {
  return incomingPayment['name'] === EMPTY_CUSTOMER_NAME ? '' : incomingPayment['name'];
}

export function getSafeCustomerName(incomingPayment: IncomingPayment): string {
  const name = getCustomerName(incomingPayment);
  if (name == null)
    throw new Error('IncomingPayment - there is no customer name');
  return name;
}
